// src/components/QrCode.js
import React from 'react';
import './styles/QrCode.css';
import qrImage from '../assets/images/qr.webp';

const QrCode = () => (
  <div className="qr-container">
     <p className="qr-text">
      Area51 is available on the Play Store. <br />
      Scan to download the app!
    </p>
    <img src={qrImage} alt="Download App QR" className="qr-img" />
  </div>
);

export default QrCode;
